import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "text-h3 text-negative" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "text-body1 q-pb-sm" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "text-uppercase text-weight-bold text-error" }
const _hoisted_9 = { class: "q-pt-sm row items-center" }
const _hoisted_10 = ["innerHTML"]

import { useDialogPluginComponent } from "quasar"
import SfxBtn from "src/components/button/SfxBtn.vue"
import SfxBtnOutline from "src/components/button/SfxBtnOutline.vue"
import SfxInput from "src/components/input/SfxInput.vue"
import { Icons } from "src/util/enums/fontAwesomeIcons"
import { SfxDialogCheckedAndInput } from "src/util/types/components/sfxDialogCheckedAndInput"
import { ref } from "vue"
import { useI18n } from "vue-i18n"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxDialogRejectPerformedWork',
  props: {
  withIssues: {
    type: Boolean,
    default: false,
  },
},
  emits: [...useDialogPluginComponent.emits],
  setup(__props) {

const props = __props



//endregion

//region Variables

const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent()

const { t } = useI18n()
const title = t("sfxDialogRejectWork.title")
const contentConfirm = t("sfxDialogRejectWork.content_confirm")
const contentIssueOne = t("sfxDialogRejectWork.content_issue_one")
const contentIssueTwo = t("sfxDialogRejectWork.content_issue_two")
const contentIssueThree = t("sfxDialogRejectWork.content_issue_three")
const contentUndone = t("sfxDialogRejectWork.content_undone")
const inputLabel = t("sfxDialogRejectWork.input_label")
const checkboxLabel = t("sfxDialogRejectWork.checkbox_content")
const confirmButtonText = t("sfxButtons.btn_confirm")
const rejectButtonText = t("sfxButtons.btn_cancel")
const widthDialog = { width: "550px" } // Because of the styles in Figma

const input = ref()
const inputRef = ref<typeof SfxInput | null>(null)
const checkboxVal = ref(false)
const payload = ref<SfxDialogCheckedAndInput>()

//endregion

//region Functions

function handleDialogOk() {
  if (inputRef.value?.validate()) {
    payload.value = { input: input.value || null, checked: checkboxVal.value }
    onDialogOK(payload.value)
  }
}

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef,
    onHide: _unref(onDialogHide)
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, {
        class: "q-dialog-plugin sfx-dialog-border-warning q-pa-sm",
        style: widthDialog
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(title)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "text-body1 q-py-sm",
                innerHTML: _unref(contentConfirm)
              }, null, 8, _hoisted_2)
            ]),
            _: 1
          }),
          (props.withIssues)
            ? (_openBlock(), _createBlock(_component_q_card_section, { key: 0 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("span", { innerHTML: _unref(contentIssueOne) }, null, 8, _hoisted_4),
                    _hoisted_5,
                    _createElementVNode("span", null, _toDisplayString(_unref(contentIssueTwo)), 1),
                    _hoisted_6,
                    _createElementVNode("span", { innerHTML: _unref(contentIssueThree) }, null, 8, _hoisted_7)
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_q_card_section, { class: "text-body1" }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(contentUndone)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _createVNode(SfxInput, {
                ref_key: "inputRef",
                ref: inputRef,
                modelValue: input.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((input).value = $event)),
                class: "q-pt-sm",
                autogrow: "",
                required: "",
                autofocus: "",
                "hide-bottom-space": "",
                label: _unref(inputLabel),
                onKeyup: _withKeys(handleDialogOk, ["enter"])
              }, null, 8, ["modelValue", "label"])
            ]),
            _: 1
          }),
          (props.withIssues)
            ? (_openBlock(), _createBlock(_component_q_card_section, { key: 1 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_q_checkbox, {
                      size: "56px",
                      class: "sfx-checkbox",
                      "checked-icon": _unref(Icons).ACCEPT,
                      modelValue: checkboxVal.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((checkboxVal).value = $event))
                    }, null, 8, ["checked-icon", "modelValue"]),
                    _createElementVNode("span", {
                      class: "q-ml-sm",
                      innerHTML: _unref(checkboxLabel)
                    }, null, 8, _hoisted_10)
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_q_card_actions, { class: "q-px-md q-pb-md q-pt-sm" }, {
            default: _withCtx(() => [
              _createVNode(SfxBtnOutline, {
                onClick: _unref(onDialogCancel),
                label: _unref(rejectButtonText),
                class: "col q-mr-sm"
              }, null, 8, ["onClick", "label"]),
              _createVNode(SfxBtn, {
                onClick: handleDialogOk,
                label: _unref(confirmButtonText),
                class: "col bg-negative text-white"
              }, null, 8, ["label"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onHide"]))
}
}

})